import React, { useState, useEffect } from "react";
import "./contact.css";

function Contact() {
  const [showAdminCodeInput, setShowAdminCodeInput] = useState(false);
  const [adminCode, setAdminCode] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [projects, setProjects] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(true);
  const [editingProjectId, setEditingProjectId] = useState(null);

  const [newProjectData, setNewProjectData] = useState({
    title: "",
    usage: [], // now array
    location: "",
    completionStatus: "Tamamlandı",
    completionDate: "",
    area: "",
    category: "Yurt İçi",
    images: [],
    forWho: "",
    video: ""
  });

  const API_BASE_URL = "https://erya-backend.onrender.com/api/projects";

  // Fetch projects
  const fetchProjects = async () => {
    setLoadingProjects(true);
    try {
      const res = await fetch(API_BASE_URL);
      if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
      const data = await res.json();
      setProjects(data);
    } catch (err) {
      console.error("Projeler yüklenirken hata oluştu:", err);
      alert("Projeler yüklenirken hata oluştu: " + err.message);
    } finally {
      setLoadingProjects(false);
    }
  };

  useEffect(() => {
    fetchProjects();

    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "a") {
        setShowAdminCodeInput((prev) => !prev);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleAdminCodeSubmit = (e) => {
    e.preventDefault();
    if (adminCode === "erya00") {
      setIsAdmin(true);
      setShowAdminCodeInput(false);
      setAdminCode("");
    } else {
      alert("Geçersiz yönetici kodu.");
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "images") {
      setNewProjectData((prev) => ({
        ...prev,
        images: prev.images ? [...prev.images, ...Array.from(files)] : Array.from(files)
      }));
    } else {
      setNewProjectData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setNewProjectData((prev) => {
      if (checked) {
        return { ...prev, usage: [...prev.usage, value] };
      } else {
        return { ...prev, usage: prev.usage.filter((u) => u !== value) };
      }
    });
  };

  const handleRemoveImage = (index) => {
    if (editingProjectId) {
      fetch(`${API_BASE_URL}/${editingProjectId}/image/${index}`, {
        method: "DELETE"
      })
        .then((res) => res.json())
        .then(() => fetchProjects())
        .catch((err) => console.error(err));
    } else {
      setNewProjectData((prev) => ({
        ...prev,
        images: prev.images.filter((_, i) => i !== index)
      }));
    }
  };

  const handleProjectSubmit = async (e) => {
  e.preventDefault();

  const formData = new FormData();

  for (let key in newProjectData) {
    if (key === "images") {
      newProjectData.images.forEach((img) => formData.append("images", img));
    } else if (Array.isArray(newProjectData[key])) {
      // ✅ send as JSON string
      formData.append(key, JSON.stringify(newProjectData[key]));
    } else {
      formData.append(key, newProjectData[key] || "");
    }
  }

  try {
    let res;
    if (editingProjectId) {
      res = await fetch(`${API_BASE_URL}/${editingProjectId}`, {
        method: "PUT",
        body: formData
      });
    } else {
      res = await fetch(API_BASE_URL, { method: "POST", body: formData });
    }

    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.error || "Bilinmeyen Hata");
    }

    alert(editingProjectId ? "Proje başarıyla güncellendi." : "Proje başarıyla eklendi.");
    setNewProjectData({
      title: "",
      usage: [],
      location: "",
      completionStatus: "Tamamlandı",
      completionDate: "",
      area: "",
      category: "Yurt İçi",
      images: [],
      forWho: "",
      video: ""
    });
    setEditingProjectId(null);
    fetchProjects();
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};


  const handleDeleteProject = async (id) => {
    if (!window.confirm("Bu projeyi silmek istediğinize emin misiniz?")) return;
    try {
      const res = await fetch(`${API_BASE_URL}/${id}`, { method: "DELETE" });
      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.error || "Bilinmeyen Hata");
      }
      fetchProjects();
      alert("Proje başarıyla silindi.");
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  if (loadingProjects) return <p>Projeler yükleniyor...</p>;

  return (
    <div className="page-container">
      <h1 className="page-title">Bize Ulaşın</h1>
      <div className="page-content">
        <section className="contact-form-section">
          <form
            action="https://formsubmit.co/info@erya-group.com"
            method="POST"
            className="contact-form styled-form"
          >
            <input type="text" name="name" placeholder="Adınız" required />
            <input type="email" name="email" placeholder="Email" required />
            <textarea name="message" placeholder="Mesajınız" required></textarea>

            <input
              type="text"
              name="adminCode"
              placeholder="Yönetici kodunu buraya giriniz"
              style={{ display: showAdminCodeInput ? "block" : "none" }}
              value={adminCode}
              onChange={(e) => setAdminCode(e.target.value)}
            />
            {showAdminCodeInput && (
              <button type="button" onClick={handleAdminCodeSubmit} className="admin-code-btn">
                Yönetici Kodunu Gönder
              </button>
            )}
            <button type="submit">Gönder</button>
          </form>
        </section>

        {isAdmin && (
          <section className="admin-panel">
            <h2>{editingProjectId ? "Projeyi Düzenle" : "Yeni Proje Ekle"}</h2>
            <form onSubmit={handleProjectSubmit} className="admin-form">
              <input
                type="text"
                name="title"
                placeholder="Proje Adı"
                value={newProjectData.title}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="forWho"
                placeholder="Yönetmen (Opsiyonel)"
                value={newProjectData.forWho || ""}
                onChange={handleChange}
              />
              <input
                type="text"
                name="video"
                placeholder="Reklam Linki (Opsiyonel)"
                value={newProjectData.video || ""}
                onChange={handleChange}
              />

              {/* ✅ Replaced Multiple Select with Checkboxes */}
              <label>Kullanım Alanları:</label>
              <div className="checkbox-group">
                {["Mimari", "Dekorasyon", "Çelik"].map((option) => (
                  <label key={option} style={{ marginRight: "10px" }}>
                    <input
                      type="checkbox"
                      value={option}
                      checked={newProjectData.usage.includes(option)}
                      onChange={handleCheckboxChange}
                    />
                    {option}
                  </label>
                ))}
              </div>

              <input
                type="text"
                name="location"
                placeholder="Proje Konumu"
                value={newProjectData.location}
                onChange={handleChange}
                required
              />
              <select
                name="completionStatus"
                value={newProjectData.completionStatus}
                onChange={handleChange}
                required
              >
                <option value="Tamamlandı">Tamamlandı</option>
                <option value="Tamamlanmadı">Tamamlanmadı</option>
              </select>
              {newProjectData.completionStatus === "Tamamlandı" && (
                <input
                  type="text"
                  name="completionDate"
                  placeholder="Tamamlanma Tarihi (YYYY-MM-DD)"
                  value={newProjectData.completionDate}
                  onChange={handleChange}
                  required
                />
              )}
              <input
                type="text"
                name="area"
                placeholder="Yapılan Alan"
                value={newProjectData.area}
                onChange={handleChange}
                required
              />
              <select
                name="category"
                value={newProjectData.category}
                onChange={handleChange}
                required
              >
                <option value="Yurt İçi">Yurt İçi</option>
                <option value="Yurt Dışı">Yurt Dışı</option>
              </select>
              <label htmlFor="images">Proje Görselleri:</label>
              <input
                type="file"
                id="images"
                name="images"
                multiple
                accept="image/*"
                onChange={handleChange}
              />

              <div className="image-preview-list">
                {newProjectData.images.map((file, idx) => (
                  <div
                    key={idx}
                    style={{ display: "inline-block", position: "relative", margin: "5px" }}
                  >
                    <img
                      src={URL.createObjectURL(file)}
                      alt={`Preview ${idx + 1}`}
                      className="image-preview"
                    />
                    <button
                      type="button"
                      onClick={() => handleRemoveImage(idx)}
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        zIndex: 999,
                        background: "red",
                        color: "white",
                        border: "none",
                        borderRadius: "50%",
                        width: "20px",
                        height: "20px",
                        cursor: "pointer"
                      }}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>

              <button type="submit" className="submit-btn">
                {editingProjectId ? "Projeyi Güncelle" : "Projeyi Ekle"}
              </button>
            </form>

            <h2>Mevcut Projeler</h2>
            <div className="existing-projects">
              {projects.map((proj) => (
                <div key={proj._id} className="project-status-item">
                  <strong>{proj.title}</strong>{" "}
                  <span>({Array.isArray(proj.usage) ? proj.usage.join(", ") : proj.usage})</span>
                  <button
                    onClick={() => handleDeleteProject(proj._id)}
                    style={{ marginLeft: "10px", color: "red" }}
                  >
                    Sil
                  </button>
                  <button
                    onClick={() => {
                      setNewProjectData({
                        title: proj.title,
                        usage: Array.isArray(proj.usage) ? proj.usage : [proj.usage],
                        location: proj.location,
                        completionStatus: proj.completionStatus || "Tamamlandı",
                        completionDate: proj.completionDate || "",
                        area: proj.area,
                        category: proj.category || "Yurt İçi",
                        images: [],
                        forWho: proj.forWho || "",
                        video: proj.video || ""
                      });
                      setEditingProjectId(proj._id);
                    }}
                    style={{ marginLeft: "5px", color: "blue" }}
                  >
                    Düzenle
                  </button>
                </div>
              ))}
            </div>
          </section>
        )}
      </div>
      <div className="map-container">
        <h2>KONUMUMUZ</h2>
        <iframe
          title="Client Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3009.1357303433813!2d28.9197486!3d41.1465361!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab35bccb63b7b%3A0x364f2a8524544811!2s%C3%87etinler%20Zanaat!5e0!3m2!1str!2str!4v1718543213124!5m2!1str!2str"
          width="100%"
          height="300"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
}

export default Contact;
